
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec148"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec148"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("jDGV0", function(module, exports) {

$parcel$export(module.exports, "insertWordPhoneticAudioContainer", () => $e4c2f3872e11aeb6$export$e3bc77f49d983863);
$parcel$export(module.exports, "insertPlayAudioBtn", () => $e4c2f3872e11aeb6$export$698c6dfa5e373328);
$parcel$export(module.exports, "insertWordMeaningsDiv", () => $e4c2f3872e11aeb6$export$36af80c08beb71ab);
$parcel$export(module.exports, "insertDefinitions", () => $e4c2f3872e11aeb6$export$94c4605e46053229);
$parcel$export(module.exports, "insertSynonymsOrAntonyms", () => $e4c2f3872e11aeb6$export$22de913a01e028a7);
$parcel$export(module.exports, "insertSource", () => $e4c2f3872e11aeb6$export$43f83b14131b6c40);

var $ablVa = parcelRequire("ablVa");

var $f7Gm2 = parcelRequire("f7Gm2");
// FUNCTIONS
function $e4c2f3872e11aeb6$export$e3bc77f49d983863(data, info, resultsContainer, getPhonetic, language, location) {
    info.phonetics = data[0].phonetics;
    resultsContainer.innerHTML = `
    <div class="word-phonetic-audio-container">
      <div class="word-phonetic-container">
        <span class="word ${(0, $f7Gm2.default).isLightTheme ? "" : "dark"}">${data[0].word}</span>
        <span class="phonetic">${getPhonetic(info.phonetics, language, location, data)}</span>
      </div>
    </div>`;
}
function $e4c2f3872e11aeb6$export$698c6dfa5e373328(isAudioAvailable, info, language, location) {
    const playAudioBtnHTML = `
      <button class="play-audio-btn">
        <svg
          class="play-audio-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="75"
          height="75"
          viewBox="0 0 75 75"
        >
          <g fill="#A445ED" fill-rule="evenodd">
            <circle cx="37.5" cy="37.5" r="37.5" opacity=".25" />
            <path d="M29 27v21l21-10.5z" />
          </g>
        </svg>
        <audio class="pronunciation-audio">
          Your browser does not support the audio element.
        </audio>
      </button>`;
    if (isAudioAvailable(info.phonetics, language, location)) {
        const wordPhoneticAudioContainer = document.querySelector(".word-phonetic-audio-container");
        wordPhoneticAudioContainer.insertAdjacentHTML("beforeend", playAudioBtnHTML);
    }
}
function $e4c2f3872e11aeb6$export$36af80c08beb71ab(meanings, index, resultsContainer) {
    const wordMeaningsHTML = `
      <div class="word-meanings">
        <div class="part-of-speech-line-container">
          <span class="part-of-speech ${(0, $f7Gm2.default).isLightTheme ? "" : "dark"}">${meanings[index].partOfSpeech}</span>
          <hr class="horizontal-line ${(0, $f7Gm2.default).isLightTheme ? "" : "horizontal-line--dark"}"/>
        </div>
        <span class="meaning-text">Meaning</span>
        <div class="meanings"></div>
      </div>`;
    resultsContainer.insertAdjacentHTML("beforeend", wordMeaningsHTML);
}
function $e4c2f3872e11aeb6$export$94c4605e46053229(meanings, index) {
    const definitions = meanings[index].definitions;
    for (let definition of definitions){
        const bulletMeaningContainerHTML = `
        <div class="bullet-meaning-container">
          <svg
            class="bullet-point"
            xmlns="http://www.w3.org/2000/svg"
            width="5"
            height="5"
            viewBox="0 0 5 5"
            fill="none"
          >
            <circle cx="2.5" cy="2.5" r="2.5" fill="#8F19E8" />
          </svg>
          <div class="word-meaning-example">
            <p class="word-meaning ${(0, $f7Gm2.default).isLightTheme ? "" : "dark"}">
             ${definition.definition}
            </p>
            ${definition.hasOwnProperty("example") ? `<p class="word-example">\u{201C}${definition.example}\u{201D}</p>` : ""}
          </div>
        </div>`;
        const meaningsDiv = document.querySelectorAll(".meanings")[index];
        meaningsDiv.insertAdjacentHTML("beforeend", bulletMeaningContainerHTML);
    }
}
function $e4c2f3872e11aeb6$export$22de913a01e028a7(meanings, index, termType, termsCount, capitalizeFirstLetter) {
    const terms = meanings[index][termType];
    if (terms.length > 0) {
        termType === "synonyms" ? termsCount.synonymsCount++ : termsCount.antonymsCount++;
        const termTypeContainerHTML = `
      <div class="${termType}-container">
        <span class="${termType}-text">${capitalizeFirstLetter(termType)}</span>
        <div class="${termType}"></div>
      </div>
      `;
        const wordMeaningsDiv = document.querySelectorAll(".word-meanings")[index];
        wordMeaningsDiv.insertAdjacentHTML("beforeend", termTypeContainerHTML);
        let termsDiv;
        // Loop over the 'terms' array and add each term to the 'terms' div
        if (termType === "synonyms") termsDiv = document.querySelectorAll(`.${termType}`)[termsCount.synonymsCount];
        else termsDiv = document.querySelectorAll(`.${termType}`)[termsCount.antonymsCount];
        for (let term of terms){
            const termHTML = `
        <span class="${termType.slice(0, -1)}">${term}</span>
      `;
            termsDiv.insertAdjacentHTML("beforeend", termHTML);
        }
    }
}
function $e4c2f3872e11aeb6$export$43f83b14131b6c40(data, word, resultsContainer) {
    const sourceUrls = data[0].sourceUrls;
    const sourceLink = sourceUrls.find((url)=>url.includes(`/${word}`));
    const sourceContainerHTML = `
<div class="source ${(0, $f7Gm2.default).isLightTheme ? "" : "source--dark"}">
  <span class="source__text ${(0, $f7Gm2.default).isLightTheme ? "" : "source__text--dark"}">Source</span>
  <div class="source__link-window">
    <a
      class="source__link ${(0, $f7Gm2.default).isLightTheme ? "" : "source__link--dark"}"
      href="${sourceLink}"
      target="_blank"
      >${sourceLink}</a
    >
    <a
      class="source__new-window-link"
      href="${sourceLink}"
      target="_blank"
    >
      <img
        class="source__new-window-icon"
        src=${(0, (/*@__PURE__*/$parcel$interopDefault($ablVa)))}
        alt="New window icon"
      />
    </a>
  </div>
</div>`;
    resultsContainer.insertAdjacentHTML("beforeend", sourceContainerHTML);
}

});
parcelRegister("ablVa", function(module, exports) {
module.exports = new URL("icon-new-window.c69f7f66.svg", import.meta.url).toString();

});


var $b73573373f94e8b8$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["eVLeH","index.9867991e.js","j2AVt","icon-new-window.c69f7f66.svg"]'));


parcelRequire("jDGV0");

//# sourceMappingURL=index.9867991e.js.map
